import component from './PageRepeatTrial.vue'
export default component
